<template>
    <div>
        <template v-if="loading">
            Loading <i class="fa fa-spinner fa-spin"></i>
        </template>
        <template v-else>
            <vue-headful :title="'[Delete Product] ' + product.product_name + ' - AMOS365'" />

            <nav aria-label="breadcrumb">
                <ol class="breadcrumb">
                    <li class="breadcrumb-item">
                        <router-link to="/products">Products</router-link>
                    </li>
                    <li class="breadcrumb-item">
                        <router-link :to="`/products/view/${product.id}`">{{ product.product_name }}</router-link>
                    </li>
                    <li class="breadcrumb-item active" aria-current="page">Delete</li>
                </ol>
            </nav>

            <h4 class="page-header">
                <span>Delete: {{ product.product_name }}</span>
            </h4>

            <div class="alert alert-warning mb-2" v-if="products.length > 0">
                This Product is currently in use by {{ products.length }} product(s). Select a Reassign Product to start mapping Products & Levels.
            </div>

            <div class="row mb-4">
                <div class="col-md-8 col-12">
                    <div class="card mb-4">
                        <div class="card-header">
                            <strong>Details:</strong>
                        </div>
                        <div class="card-body">
                            <div v-if="in_use">
                                <div class="alert alert-info mb-3">
                                    This product is in use on contracts and/or policies. Select a replacement product below to reassign all these data points to.
                                </div>
                                <div class="row mb-1">
                                    <div class="col-lg-3 col-md-4 col-12 text-md-right" :class="{'text-danger': errors.reassign_product_id, 'text-muted-no': !errors.reassign_product_id}">
                                        Re-Assign Product:
                                    </div>
                                    <div class="col-md-8 col-12 input-group-sm">
                                        <b-form-select v-model="reassign_product_id" :options="productOptions" :class="{'is-invalid': errors.reassign_product_id}" />

                                        <div class="text-danger mt-2" v-if="errors.reassign_product_id">
                                            <ul class="list-unstyled">
                                                <li v-for="err in errors.reassign_product_id">{{ err }}</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-else class="alert alert-danger">
                                Confirm Product Delete. This cannot be undone.
                            </div>
                        </div>
                    </div>

                    <div class="card mb-4" v-if="product.levels.length > 0 && reassign_levels.length > 0">
                        <div class="card-header">
                            <strong>Map Existing Levels to New Product:</strong>
                        </div>
                        <div class="card-body">
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th>Existing Level</th>
                                        <th>New Level</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(level, i) in product.levels">
                                        <td>
                                            {{ level.product_level_name }}
                                        </td>
                                        <td>
                                            <b-form-select v-model="level.reassign_level_id" :options="reassignLevelOptions" size="sm" />

                                            <span v-if="errors['levels.'+i+'.reassign_level_id']" class="text-danger">
                                                <span v-for="err in errors['levels.'+i+'.reassign_level_id']">
                                                    {{ err }}
                                                </span>
                                            </span>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <div class="col-md-4 col-12" v-if="product.levels.length > 0">
                    <div class="card mb-4">
                        <div class="card-header">
                            <strong>Levels ({{ product.levels.length }}):</strong>
                        </div>
                        <div class="card-body">
                            <ol class="list-unstyled">
                                <li v-for="level in product.levels">
                                    {{ level.product_level_name }}
                                </li>
                            </ol>
                        </div>
                    </div>
                </div>
            </div>

            <div class="mt-4">
                <button type="button" class="btn btn-sm btn-danger" v-on:click="deleteProduct()" :disabled="deleting">
                    <template v-if="deleting"><i class="fas fa-spin fa-spinner"></i> Deleting...</template>
                    <template v-else><i class="fas fa-save"></i> Delete</template>
                </button>
            </div>
        </template>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                loading: true,
                deleting: false,
                reassign_product_id: null,
                in_use: false,
                id: this.$route.params.id,
                product: {},
                errors: {},
                products: [],
                other_products: [],
                reassign_levels: [],
            }
        },

        computed: {
            productOptions(){
                //Setup
                var options = [{value: null, text: '-- Select a Product --'}];

                //Main Loop
                for(var i = 0; i < this.other_products.length; i++)
                {
                    options.push({value: this.other_products[i].id, text: this.other_products[i].product_name});
                }

                //Send it
                return options;
            },

            resassignProductOptions(){
                //Setup
                var options = [{value: null, text: '-- Select a Product --'}];

                //Main Loop
                for(var i = 0; i < this.reassign_products.length; i++)
                {
                    options.push({value: this.reassign_products[i].id, text: this.reassign_products[i].product_name});
                }

                //Send it
                return options;
            },

            reassignLevelOptions(){
                //Setup
                var options = [{value: null, text: '-- Select a Product Level --'}];

                //Main Loop
                for(var i = 0; i < this.reassign_levels.length; i++)
                {
                    options.push({value: this.reassign_levels[i].id, text: this.reassign_levels[i].product_level_name});
                }

                //Add New
                options.push({value: 'new', text: '-- Add Level to Product --'});

                //Send it
                return options;
            },
        },

        watch: {
            reassign_product_id(newVal, oldVal){
                //Check for a value
                if(newVal == null)
                {
                    //REset
                    this.reassign_products = [];
                    this.reassign_levels = [];

                    //Stop Here
                    return;
                }

                //Get the Product
                this.getReassignProductLevels();
            },
        },

        methods: {

            getProduct(){
                //Send it
                this.$http.get('/products/delete/' + this.id)
                    .then(response => {
                        //Set the product
                        this.in_use = response.data.in_use;
                        this.product = response.data.product;
                        this.other_products = response.data.other_products;
                    })
                    .catch(error => {

                    })
                    .then(() => {
                        //Reset
                        this.loading = false;
                    });
            },

            getReassignProductLevels(){
                //Loop through the products and set the levels
                for (var i = 0; i < this.other_products.length; i++)
                {
                    if(this.other_products[i].id == this.reassign_product_id)
                    {
                        //Set the levels
                        this.reassign_levels = this.other_products[i].levels;
                    }
                }

                //Attempt to Map the Reassign Levels to the Delete Levels
                for (var i = 0; i < this.product.levels.length; i++)
                {
                    for (var j = 0; j < this.reassign_levels.length; j++)
                    {
                        if(this.product.levels[i].product_level_name == this.reassign_levels[j].product_level_name)
                        {
                            //Set it
                            this.product.levels[i].reassign_level_id = this.reassign_levels[j].id;
                        }
                    }

                    //Check if set
                    if(typeof this.product.levels[i].reassign_level_id == 'undefined')
                    {
                        this.product.levels[i].reassign_level_id = null;
                    }
                }
            },

            deleteProduct(){
                //Helpers
                this.deleting = true;

                //Reset ERror
                this.errors = {};

                //Send it
                this.$http
                .delete('products/delete/'+this.id, {reassign_product_id: this.reassign_product_id, levels: this.product.levels})
                .then(response => {
                    //Alert the user?
                    this.$toastr.s('Product Deleted');

                    //Return to main list?
                    this.$router.push('/products');
                })
                .catch(error => {
                    //Check for error
                    if(error.response.status === 422)
                    {
                        //Display validation errors
                        this.errors = error.response.data.errors;

                        //Alert
                        this.$toastr.e('Validation Errors Occurred');
                    }
                    else
                    {
                        //Alert the user
                        this.$toastr.e(error.response.data, 'Failed to Delete Product');
                    }
                })
                .then(response => {
                    //SHow loading
                    this.deleting = false;
                });
            },

            resassignLevelOptions(product_id){
                //Setup
                var options = [{value: null, text: '-- Select a Level --'}];

                //Main Loop
                for(var i = 0; i < this.reassign_products.length; i++)
                {
                    //Check ID
                    if(this.reassign_products[i].id === product_id)
                    {
                        //Main Loop
                        for(var j = 0; j < this.reassign_products[i].levels.length; j++)
                        {
                            options.push({value: this.reassign_products[i].levels[j].id, text: this.reassign_products[i].levels[j].product_level_name});
                        }
                    }
                }

                //Send it
                return options;
            },

            reassignProductName(product_id)
            {
                //Main Loop
                for(var i = 0; i < this.reassign_products.length; i++)
                {
                    //Check ID
                    if(this.reassign_products[i].id === product_id)
                    {
                        return this.reassign_products[i].product_name;
                    }
                }

                return '';
            }
        },

        mounted() {
            //get the product?
            this.getProduct();
        }
    }
</script>
